@if (block) {
  <section
    class="login-promo"
    *ngIfMediaQuery="'(min-width: 640px)'; else mobileImageTmp"
    [cropImage]="block.mediaImage | preSignedUrl | async"
    [style.color]="block.textColor"
    [additionalOptions]="{width: 1920}">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </section>
  <ng-template #mobileImageTmp>
    @if ((block.mediaImagePhone || block.mediaImage); as mobileImage) {
      <section
        class="login-promo"
        [cropImage]="mobileImage | preSignedUrl | async"
        [additionalOptions]="{ width: 600 }">
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </section>
    }
  </ng-template>
}

<ng-template #content>
  <div class="content block-container">
    <h1 [innerHtml]="block.title | safeHtml" [rtl]="block.langcode"></h1>
    @if (block.subTitle) {
      <p class="subtitle" [innerHtml]="block.subTitle | safeHtml" [rtl]="block.langcode"></p>
    }
    <div class="buttons-wrapper">
      @if (registrationButtonVisible) {
        <button mat-flat-button class="register button button--large" [style.background-color]="block.registerButtonColor" [style.color]="block.registerButtonTextColor" [routerLink]="['/access', 'register']">
          <span>{{'COMMON.register' | translate }}</span>
          <mat-icon iconPositionEnd>navigate_next</mat-icon>
        </button>
      }
      <button mat-flat-button class="sign-in button button--primary button--large" [style.background-color]="block.loginButtonColor" [style.color]="block.loginButtonTextColor" [routerLink]="['/access', 'login']">
        <span>{{'COMMON.sign_in' | translate }}</span>
        <mat-icon iconPositionEnd>navigate_next</mat-icon>
      </button>
    </div>
  </div>
</ng-template>
